import React from 'react';
import { components as selectComponents } from 'react-select';
import type { GroupBase, OptionProps } from 'react-select';
import { AttributeWidgetOption } from '../../NodeEditorDrawer/ThresholdsTab/RuleBuilderContainer/Rule/Threshold/AttributeWidgetOption';
import type { DropdownOption } from '../../NodeEditorDrawer/types';

/**
 * Draws a min/max option's name in pink, while the rest of its label — the ` (a, b, c...)` — keeps
 * the default colour. Every other option is left to AttributeWidgetOption.
 */
export const ExpressionOption = (
  optionProps: OptionProps<unknown, boolean, GroupBase<unknown>>,
) => {
  const { data } = optionProps;
  const { label, meta } = data as DropdownOption;

  if (meta?.category === 'function' && meta.shortenedLabel) {
    const rest = label.slice(meta.shortenedLabel.length);

    return (
      // isSelected off so react-select does not mute the option matching the current value
      <selectComponents.Option {...optionProps} isSelected={false}>
        <span style={{ color: 'var(--cl-pink-600)' }}>{meta.shortenedLabel}</span>
        {rest}
      </selectComponents.Option>
    );
  }

  return <AttributeWidgetOption {...optionProps} />;
};
